import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/bell-curve',
        name: 'bell-curve',
        component: () => import('@/pages/bell-curve/BellCurveParent.vue'),
        meta: {
            dataTablePage: true,
            middleware: [GateKeeperMiddleware],
            ability: ({ gateKeeper }) =>
                gateKeeper.userHasPermission('view any anomaly detection result') || gateKeeper.userIsGroupInstructor(),
        },
    },
];
